import React from 'react';
import styled from 'styled-components';
import { rhythm } from 'Themes/typography';

const Container = styled.div`
  width: 100%;
  padding-bottom: ${rhythm(0.8)};
`;

const Heading = styled.h3`
  font-size: 1rem;
  margin-bottom: ${rhythm(0.5)};
`;

const ContainerShortListed = styled.div`
  width: 100%;
  padding-bottom: ${rhythm(0.3)};
`;

const HeadingShortListed = styled.h3`
  font-size: 1rem;
  padding-bottom: ${rhythm(0.1)};
  margin-bottom: 0;
  border-bottom: 1px solid ${({ theme }) => theme.palette.blue.light};
`;

class Section extends React.PureComponent {
  render() {
    const { name, children, shortlisted } = this.props;
    return (
      <React.Fragment>
        {!shortlisted ? (
          <Container>
            <Heading>{name}</Heading>
            <div>{children}</div>
          </Container>
        ) : (
          <ContainerShortListed>
            <HeadingShortListed>{name}</HeadingShortListed>
            <div>{children}</div>
          </ContainerShortListed>
        )}
      </React.Fragment>
    );
  }
}

export default Section;
